module.exports = __webpack_public_path__ + "2023124:cb48231cec1aa2d91890/img/tmm-web-desk.360e8e2.webp";